var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        { attrs: { span: 7 } },
        [
          _c("el-tree", {
            attrs: {
              data: _vm.fileTree,
              "expand-on-click-node": false,
              "default-expand-all": "",
              "highlight-current": "",
            },
            on: { "node-click": _vm.handleNodeClick },
          }),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 17 } },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            _vm._l(_vm.data, function (item) {
              return _c(
                "el-tab-pane",
                {
                  key: item.k,
                  attrs: { lazy: true, label: item.k, name: item.k },
                },
                [
                  _c("Java", {
                    attrs: { id: "target", value: item.v, height: "600px" },
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "copy",
                      attrs: {
                        id: "btn",
                        type: "text",
                        size: "small",
                        icon: "el-icon-document-copy",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.copyLink(item.v)
                        },
                      },
                    },
                    [_vm._v("\n          复制\n        ")]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }